<template>
  <div :class="{ 'ca-Carousel_Wrapper-inverted': inverted }" class="swiper-container">
    <div
      @mouseenter="stopAutoplay"
      @mouseleave="resumeAutoplay"
      class="swiper-wrapper ca-Carousel_Wrapper"
    >
      <slot></slot>
    </div>
    <div ref="pagination" v-if="pagination" class="fader-pagination" />
    <div
      ref="prev"
      v-if="arrows"
      class="ca-Carousel_IconWrapper appear ca-Carousel_IconWrapperPrev d-none d-lg-block"
    >
      <div class="ca-Carousel_IconContainer">
        <ChevronLeft class="svg-24 svg-fill-current" />
      </div>
    </div>
    <div
      ref="next"
      v-if="arrows"
      class="ca-Carousel_IconWrapper appear ca-Carousel_IconWrapperNext d-none d-lg-block"
    >
      <div class="ca-Carousel_IconContainer">
        <ChevronRight class="svg-24 svg-fill-current" />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/js/swiper.min.js";
import ChevronRight from "../../icons/atalanda/chevron-right.svg";
import ChevronLeft from "../../icons/atalanda/chevron-left.svg";

export default {
  name: "Carousel",
  components: {
    ChevronRight,
    ChevronLeft,
  },
  props: {
    slidesPerView: {
      type: [Number, Object],
      default: 1,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
    fade: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    inverted: {
      type: Boolean,
    },
  },
  data() {
    return {
      instance: undefined,
      showNavigation: true,
      loop: false,
      autoplayConfig: this.autoplay
        ? {
            delay: 6000,
          }
        : false,
    };
  },
  mounted() {
    this.instance = this.init();
  },
  beforeDestroy() {
    this.instance.destroy();
  },
  methods: {
    init() {
      if (this.$slots.default) {
        this.addSwiperSlideClass();
        this.loop = this.$slots.default.length > 1;
        return this.initSwiperInstance();
      }
    },
    addSwiperSlideClass() {
      this.$slots.default.forEach(vnode => {
        const element = vnode.elm;
        element.classList.add("swiper-slide");
      });
    },
    initSwiperInstance() {
      let slidesPerView = 1;

      return new Swiper(this.$el, {
        autoHeight: this.autoHeight,
        autoplay: this.autoplayConfig,
        slidesPerView: slidesPerView,
        lazy: {
          loadPrevNext: true,
        },
        loop: this.loop,
        effect: this.fade ? "fade" : null,
        watchOverflow: true,
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
        },
      });
    },
    stopAutoplay() {
      if (this.autoplay) {
        this.instance.autoplay.stop();
      }
    },
    resumeAutoplay() {
      if (this.autoplay) {
        this.instance.autoplay.start();
      }
    },
  },
};
</script>
<style lang="scss">
@import "~swiper/css/swiper";
@import "~styles/global";

.ca-Carousel_Wrapper {
  align-items: center;
}

.ca-Carousel_Wrapper-inverted {
  --carousel-color: #{$black};
  --carousel-hover-color: #{$white};
}

.swiper-button-disabled {
  opacity: 0.5;
  transition: opacity $transition-duration-short;
}

.swiper-button-hidden {
  display: none !important;
}

.swiper-container > .swiper-button-lock {
  display: none !important;
}

.fader-pagination {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0;
  z-index: $zi-high;

  &.swiper-pagination-bullets {
    bottom: $spacer-1;

    @media (min-width: $screen-sm-min) {
      bottom: $spacer-2;
    }
  }
}

.fader-pagination .swiper-pagination-bullet {
  display: block;
  margin: 0 $spacer-1;
  width: $spacer-2;
  height: $width-border-medium;
  border-radius: $border-radius;
  background: $white;
  background: var(--carousel-color, $white);
  opacity: $opacity-half-visible;

  &:only-child {
    visibility: hidden;
  }

  @media (min-width: $screen-sm-min) {
    width: $spacer;
    height: $width-border-medium;
  }
}

.fader-pagination .swiper-pagination-bullet-active {
  background: $white;
  background: var(--carousel-color, $white);
  opacity: 1;
}

.ca-Carousel_IconWrapper {
  position: absolute;
  top: 50%;
  z-index: $zi-lowest;
  transform: translateY(-50%);
  border-radius: 50%;
  border: $width-border-medium solid $white;
  border-color: var(--carousel-color, $white);
  color: $white;
  color: var(--carousel-color, $white);
  transition: color $transition-duration, background-color $transition-duration,
    border-color $transition-duration;

  @include hover-states {
    color: $gray-900;
    color: var(--carousel-hover-color, $gray-900);
    background-color: $white;
    background-color: var(--carousel-color, $white);
    text-decoration: none;
    cursor: pointer;
    border-color: $white;
    border-color: var(--carousel-color, $white);
  }
}

.ca-Carousel_IconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: $width-slick-slider-icon;
  height: $width-slick-slider-icon;
}

.ca-Carousel_IconWrapperNext {
  right: $spacer-2;
}

.ca-Carousel_IconWrapperPrev {
  left: $spacer-2;
}
</style>
